<template>
  <div class="alert alert-secondary" role="alert">
    <div class="alert-text">
      <h5 class="text-center mb-4">
        Read before confirming. <br> Any {{ type_name }} deleted by retention rules are unrecoverable
      </h5>
      <p class="font-weight-bold mt-2">
        {{ type_name }} will be deleted when :
      </p>
      <p v-if="is_item_type">
        <span v-if="has_tags">
          a) They were {{ check_against_name }} more than {{ retention_days }} days ago <br>
          b) Has one of the following tags: <span v-for="tag in retention.tags" :key="tag">{{ tag }},</span>
        </span>
        <span v-else>
          They were {{ check_against_name }} more than {{ retention_days }} days ago
        </span>
      </p>
      <p v-else>
        When they were {{ check_against_name }} more than {{ retention_days }} days ago
      </p>

      <p class="font-weight-bold">
        Related {{ related_name }}
      </p>
      <p>
        <span v-if="retention.delete_related">
          You have chosen to 'delete related'.
          <span v-if="is_item_type">
            The item's storage asset will also be deleted preventing a build up of unused storage.
          </span>
          <span v-else>
            If an item is using this storage asset, it will also be deleted preventing orphaned items.
          </span>
        </span>
        <span v-else>
          You have chosen to not 'delete related'.
          <span v-if="is_item_type">
            The storage asset will be kept, leaving it as unused storage.
          </span>
          <span v-else>
            The item using the storage asset will be left orphaned and un-usable.
          </span>
        </span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    retention: {
      type: Object,
      required: true,
    },
  },
  computed: {
    is_item_type() {
      return this.retention.type === 'item';
    },
    has_tags() {
      return this.is_item_type && this.retention?.length;
    },
    type_name() {
      return this.is_item_type ? 'Items' : 'Storage Assets';
    },
    related_name() {
      return this.is_item_type ? 'Storage Assets' : 'Items';
    },
    check_against_name() {
      if (!this.is_item_type) {
        return 'created';
      }

      if (this.retention.check_against === 'created_at') {
        return 'created';
      }
      if (this.retention.check_against === 'publish_start') {
        return 'published';
      }
      return `created`;
    },
    retention_days() {
      return this.retention.retention_days ? this.retention.retention_days : 0;
    },
  },
};
</script>
